const hasVariantByIdInCartSelectorUtil = (props) => {
  const { cartItem } = props
  // logUtil('hasVariantByIdInCartSelectorUtil').debug('props=', props)
  return !!cartItem
}

export default hasVariantByIdInCartSelectorUtil
